import { usePageDescription } from '@/core/page';
import { comingSoonDescription } from './coming-soon';
import { type Icon, Sparkle } from './icons';
import { Card } from './Card';

/** Área prevista na navegação, mas ainda sem contexto no back. */
export function ComingSoon({
  title,
  description,
  icon: Icon = Sparkle,
}: {
  title: string;
  description: string;
  icon?: Icon;
}) {
  usePageDescription(() => comingSoonDescription(title, description));
  return (
    <div className="mx-auto max-w-lg px-4 py-16">
      <Card className="flex flex-col items-center px-8 py-14 text-center">
        <span className="flex size-12 items-center justify-center rounded-xl bg-brand-400 text-on-brand">
          <Icon aria-hidden className="size-6" />
        </span>
        <h1 className="mt-5 text-xl font-semibold">{title}</h1>
        <p className="mt-2 text-sm text-fg-subtle">{description}</p>
        <span className="mt-6 rounded-full bg-surface-2 px-3 py-1 text-xs font-medium text-fg-muted">
          Em breve
        </span>
      </Card>
    </div>
  );
}
